import { CustomSVGProps } from './CustomSVGProps.types';

export function IconLinkedin24(props: CustomSVGProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden={!props.onClick}
            aria-label="linkedin"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14ZM8.34 9.67H5.67V18h2.67V9.67ZM7 6a1.34 1.34 0 1 0 0 2.68A1.34 1.34 0 0 0 7 6Zm11 6.6c0-2.2-1.18-3.22-2.75-3.22-1.27 0-1.84.7-2.16 1.19V9.67h-2.67V18h2.67v-4.36c0-.23.02-.46.09-.62.18-.46.6-.94 1.3-.94.92 0 1.29.7 1.29 1.73V18H18v-5.4Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
